import type { FunctionComponent } from 'react';

import { ContentMarkdown } from '../../../shared/components/content-markdown/content-markdown';
import { useHeading } from '../../../shared/hooks/use-heading';
import { useMarkdown } from '../../../shared/hooks/use-markdown';
import { createClassName, createStyleHelper } from '../../../shared/utils/class-names';
import { TableOfContents } from '../table-of-content/table-of-content';

import styles from './document.module.scss';

const style = createStyleHelper(styles, 'document-page');

export interface IDocumentProps {
    className?: string;
    content: string;
}

export const DocumentPage: FunctionComponent<IDocumentProps> = ({ className, content }) => {
    const markdown = useMarkdown(content);
    const headings = useHeading(markdown);

    return (
        <div className={createClassName([className, style()])}>
            {headings.length > 0 ? <TableOfContents headings={headings} /> : null}
            <ContentMarkdown markdown={markdown} />
        </div>
    );
};
